import React, { cloneElement, useEffect, useState } from 'react';
import './index.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { fallBackLocale, isDevelopment, localeToLngName, lngNameToLocale, RoutePath } from '../../constants';
import { flagSources, getCountryCode, getQueryParamString } from '../../util';
import { REACT_APP_CONTEXT_PATH } from '../../config';

import PropTypes from 'prop-types';
import LangaugeDropDown from './LangaugeDropDown';
import { useDisplayQueryParam } from '../../hooks';

const OnStarContainer = (props) => {
  const { children, title } = props;
  const history = useHistory();
  useDisplayQueryParam();
  const { i18n } = useTranslation();
  const locale = i18n.language;

  const [selectedLngName, setSelectedLngName] = useState(localeToLngName[locale] || localeToLngName[fallBackLocale]);

  const countryCode = getCountryCode(locale);

  useEffect(() => {
    const lngCode = lngNameToLocale[selectedLngName];
    i18n.changeLanguage(lngCode);
  }, [i18n, selectedLngName]);

  useEffect(() => {
    document.title = title;
  });

  const handleChange = (evt) => {
    setSelectedLngName(evt.target.value);
  };

  const handleLogout = () => {
    history.push({ pathname: RoutePath.logout, search: getQueryParamString() });
  };

  return (
    <>
      {isDevelopment && (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '1em' }}>
          <LangaugeDropDown
            flagSource={flagSources[countryCode]}
            countryCode={countryCode}
            selectedLngName={selectedLngName}
            handleChange={handleChange}
          />
          <button id='logout-btn' className='square-button' onClick={handleLogout}>
            logout
          </button>
        </div>
      )}
      <div className='onstar-container'>
        <header className='header'>
          <div className='main-title'>{title}</div>
        </header>
        <div className='content'>{children && cloneElement(<>{children}</>, { ...props })}</div>
        <div className='footer'>
          <div className='footer-image-container'>
            <img
              src={`${REACT_APP_CONTEXT_PATH}/assets/images/footer.png`}
              alt='OnStar Logo'
              className='footer-image'
            />
          </div>
        </div>
      </div>
    </>
  );
};

OnStarContainer.propTypes = {
  title: PropTypes.string,
};

export default OnStarContainer;
